module.exports = __webpack_public_path__ + "static/media/10.Demolition hammer 16kg.de7ea3fc.jpg";